export enum SavedRepliesRoutes {
  root = 'saved-replies',
  create = 'create',
}
